import { DataTableColumnHeader } from '@/components/core';
import { formatDateOnly, formatOrgDateTime } from '@/lib/utils/custom-date/custom-date';
import { ColumnDef } from '@tanstack/react-table';
import { LunchRequest } from '../../types/lunch.types';

interface CreateRequestHistoryTableColumnsProps {
  t: (key: string) => string;
}

export const createRequestHistoryTableColumns = ({
  t,
}: CreateRequestHistoryTableColumnsProps): ColumnDef<LunchRequest>[] => [
  {
    id: 'RequestedForDate',
    meta: { filter: { type: 'date' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('DATE')} />,
    accessorFn: (row) => row.RequestedForDate ?? '',
    cell: ({ row }) => formatDateOnly(row.original.RequestedForDate) || '-',
  },
  {
    id: 'MenuName',
    meta: { filter: { type: 'text' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('LUNCH_MENU')} />,
    accessorFn: (row) => row.MenuName ?? '-',
  },
  {
    id: 'CreatedDate',
    meta: { filter: { type: 'datetime' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('REQUESTED_ON')} />,
    accessorFn: (row) => row.CreatedDate ?? '',
    cell: ({ row }) =>
      row.original.CreatedDate ? formatOrgDateTime(row.original.CreatedDate) : '-',
  },
];
